import { Lock } from "lucide-react";
import { TotpQr } from "../users/TotpQr";

export function LoginMfaSetup({
  username,
  secret,
  otpauth,
  otp,
  onOtp,
}: {
  username: string;
  secret: string;
  otpauth: string;
  otp: string;
  onOtp: (value: string) => void;
}) {
  return (
    <div className="login-mfa-setup">
      <div className="login-mfa-setup-body">
        <p className="login-step-note">
          Authenticator App is required. Scan the QR for <strong>{username}</strong>, or enter the setup key below,
          then type the 6-digit code.
        </p>
        <div className="login-mfa-qr-wrap">
          {otpauth ? <TotpQr otpauth={otpauth} /> : <p className="login-step-note">QR is unavailable. Use the setup key.</p>}
        </div>
        {secret ? (
          <div className="login-mfa-secret">
            <span className="login-mfa-secret-label">Setup key</span>
            <code className="login-mfa-secret-value">{secret}</code>
          </div>
        ) : null}
      </div>
      <label className="sr-only" htmlFor="otp-setup">
        Authenticator App code
      </label>
      <div className="login-field login-field-spaced">
        <Lock className="login-field-icon" />
        <input
          id="otp-setup"
          name="otp"
          inputMode="numeric"
          autoComplete="one-time-code"
          value={otp}
          onChange={(event) => onOtp(event.target.value.replace(/\D/g, "").slice(0, 6))}
          className="login-input"
          placeholder="6-digit code"
          required
        />
      </div>
    </div>
  );
}
